<template>
  <div class="faq">
    <div
      v-for="(item, index) in faqs"
      :key="index"
      class="dropdown-faq"
      :class="{ 'is-open': activeIndex === index }"
    >
      <button
        type="button"
        class="faq-title"
        :aria-expanded="activeIndex === index"
        @click="toggleFaq(index)"
      >
        <span class="faq-question">{{ item.question }}</span>
        <span class="faq-icon" aria-hidden="true"></span>
      </button>

      <div v-show="activeIndex === index" class="faq-answer">
        <p class="content" v-html="item.answer"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    faqs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  methods: {
    toggleFaq(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>

<style lang="scss" scoped>
.faq {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dropdown-faq {
  background: #fff;
  border: 1px solid #dfe7f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(53, 84, 143, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: #c9d6e8;
    box-shadow: 0 12px 24px rgba(53, 84, 143, 0.08);
    transform: translateY(-1px);
  }

  &.is-open {
    border-color: #b8c9e8;
    box-shadow: 0 14px 30px rgba(53, 84, 143, 0.1);
  }
}

.faq-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px 18px;
  border: none;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease;

  &:hover {
    background: #f0f4fa;
  }

  .is-open & {
    background: #eef4fb;
    border-bottom: 1px solid #dce3ec;
  }
}

.faq-question {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  color: #35548f;
}

.faq-icon {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-right: 2px solid #35548f;
  border-bottom: 2px solid #35548f;
  transform: rotate(45deg);
  margin-top: -4px;
  transition: transform 0.25s ease;

  .is-open & {
    transform: rotate(-135deg);
    margin-top: 4px;
  }
}

.faq-answer {
  padding: 14px 18px 18px;
  background: #fff;
}

.content {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: #555;
}
</style>
